const pages = {
  products: [
    {
      title: 'Pipy',
      href: '/pipy',
    },
    {
      title: 'ZTM',
      href: '/ztm',
    },
    {
      title: 'FLB',
      href: '/flb',
    },
    // {
    //   title: 'OSM Edge',
    //   href: '/osm-edge',
    // },
    {
      title: 'FSM',
      href: '/fsm',
    }
  ],
  githubs: [
    {
      title: 'Pipy',
      href: 'https://github.com/flomesh-io/pipy',
			target: '_blank'
    },
    {
      title: 'ZTM',
      href: 'https://github.com/flomesh-io/ztm',
			target: '_blank'
    },
    {
      title: 'FSM',
      href: 'https://github.com/flomesh-io/fsm',
			target: '_blank'
    }
  ],
};

export default pages;
